import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { PageState } from 'app/store/models/page.model';

import { setBannerComponent } from 'app/store/actions/page.action';
import { ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { PriceCard, PriceCardColor } from 'app/store/models/price-card.model';
import { faSuitcase, faUser, faUsers } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
})
export class PricingComponent implements OnInit {
  pricingCards: PriceCard[] = [
    {
      buttons: [
        {
          color: ButtonColor.ORANGE,
          text: 'Sign up',
          route: ['/register'],
          size: ButtonSize.NORMAL,
        },
      ],
      iconName: faUser,
      info: {
        title: '$149',
        subtitle: 'Per Month',
        extra: 'Setup Fee: $500',
      },
      text: 'Select this plan if you are an individual sales professional. Includes everything you need to start setting meetings and following up with prospects and clients. You basically are about to hire your most effective sales assistant ever.',
      title: 'Individual',
      color: PriceCardColor.ORANGE,
    },
    {
      buttons: [
        {
          color: ButtonColor.GREEN,
          text: 'Sign up!',
          route: ['/register'],
          size: ButtonSize.NORMAL,
        },
      ],
      iconName: faUsers,
      info: {
        title: '$298',
        subtitle: 'Per Month',
        extra: 'Setup Fee: $500',
      },
      text: 'Select this plan if you are a manager and want to add at least two (2) team members to Retreva. This plan comes with a manager dashboard and reporting and two (2) Individual accounts. Additional Individual accounts can be added to your team anytime.',
      title: 'Team',
      color: PriceCardColor.GREEN,
    },
    {
      buttons: [
        {
          color: ButtonColor.BLUE,
          text: 'Contact us!',
          route: ['/contact_us'],
          size: ButtonSize.NORMAL,
        },
      ],
      iconName: faSuitcase,
      info: {
        title: 'Call',
        subtitle: 'For details',
      },
      text: 'If you have a large team or you are wondering how Retreva will work with your existing CRM or Email Marketing platforms, Contact Us and we would be happy to create the perfect solution for your company.',
      title: 'Enterprise',
      color: PriceCardColor.BLUE,
    },
  ];

  constructor(private store: Store<PageState>) {
    this.store.dispatch(setBannerComponent({ banner: 'Our Pricing' }));
  }

  ngOnInit() {
  }
}
